module.exports = __webpack_public_path__ + "static/TTNormsProBold-07583b08ad8c460ea96c1a9328a786d5.woff";